// @flow
import React, { type Node } from 'react';

import styles from './CellStatus.module.scss';;


type Props = {
  id: string,
  color: string,
  statusTitle: string,
}

const CellStatus = ({ id, color, statusTitle }: Props): Node => {
  return (
    <div className={styles.root}>
      <div className={styles.indicator}>
        <div className={styles.circle} style={{ backgroundColor: color }} />
      </div>
      <div className={styles.number}>{id}</div>
      <div className={styles.status} style={{ color }}>
        {statusTitle}
      </div>
    </div>
  );
};

export default CellStatus;
